/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserRequest } from '../../models/get-user-request';
import { GetUserResponse } from '../../models/get-user-response';

export interface UserServiceGetUser2$Params {
      body: GetUserRequest
}

export function userServiceGetUser2(http: HttpClient, rootUrl: string, params: UserServiceGetUser2$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUser2.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserResponse>;
    })
  );
}

userServiceGetUser2.PATH = '/api/v3/gateway/user';
